<template>
    <div class="container">
        <div class="fixed-cards">
            <el-card v-for="item in tableData" :key="item.shopName" shadow="hover" class="card">
                <div slot="header" class="clearfix">
                    <span>基础信息:</span>
                </div>
                <div class="card-content">
                    <el-row>
                        <el-col :span="8"><strong>工程项目名称:</strong> {{ item.goodsName }}</el-col>
                        <el-col :span="8"><strong>所属商户:</strong> {{ item.shopName }}</el-col>
                        <el-col :span="8"><strong>商户电话:</strong> {{ item.shopMobile }}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8"><strong>报备人:</strong> {{ item.contactName||item.customName }}</el-col>
                        <el-col :span="8"><strong>联系方式:</strong> {{ item.contactMobile||item.customMobile }}</el-col>
                        <el-col :span="8"><strong>项目地址:</strong> {{ item.customAddress }}</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8"><strong>服务监理:</strong> {{ item.engineeringSupervisorName }}</el-col>
                        <el-col :span="8"><strong>服务监理电话:</strong> {{ item.engineeringSupervisorMobile }}</el-col>
                        <el-col :span="8"><strong>服务状态:</strong> <el-tag v-if="item.status == 'DONE'" type="success"> {{
                            getStatusLabel(item.status) }}</el-tag>
                            <el-tag v-else-if="item.status == '2'" type="WAIT_PAY"> {{ getStatusLabel(item.status)
                                }}</el-tag>
                            <el-tag v-else-if="item.status == '3'" type="RETURNED"> {{ getStatusLabel(item.status)
                                }}</el-tag>
                            <el-tag v-else>{{ getStatusLabel(item.status) }}</el-tag>
                        </el-col>
                    </el-row>
                    <div v-if="item.imageUrl" class="form-row">
                        <p><strong>图片:</strong>
                            <viewer :images="formmaterImage(item.imageUrl)">
                                <img v-for="src in formmaterImage(item.imageUrl)" :src="src" :key="src"
                                    class="card-image" />
                            </viewer>
                        </p>
                    </div>
                </div>
            </el-card>
        </div>
        <div v-if="isShow" class="fixed-cards">
            <!-- 服务项目选择表格 -->
            <el-card shadow="hover" class="card">
                <div slot="header" class="clearfix">
                    <span>服务项目列表:</span>
                </div>
                <div class="card-content">
                    <el-table :data="selectedGoods" style="width: 100%" border>
                        <el-table-column prop="goodsName" label="服务项目名称">
                        </el-table-column>
                        <!--服务工程师电话 -->
                        <el-table-column prop="engineerName" label="服务工程师">
                            <template slot-scope="scope" v-if="scope.row.engineerName || scope.row.engineerMobile">
                                {{ scope.row.engineerName }}({{ scope.row.engineerMobile }})
                            </template>
                        </el-table-column>
                        <!-- 工单状态 -->
                        <el-table-column prop="status" label="状态">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.status == 'DONE'" type="success"> {{ getStatusLabel(scope.row.status)
                                    }}</el-tag>
                                <el-tag v-else-if="scope.row.status == '2'" type="WAIT_PAY"> {{
                                    getStatusLabel(scope.row.status) }}</el-tag>
                                <el-tag v-else-if="scope.row.status == '3'" type="RETURNED"> {{
                                    getStatusLabel(scope.row.status) }}</el-tag>
                                <el-tag v-else>{{ getStatusLabel(scope.row.status) }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button :disabled="!scope.row.id" type="success" icon="el-icon-view"
                                    @click="viewWorkOrder(scope.row)" style="margin-top: 10px;">
                                    工单
                                </el-button>
                                <!--  <div v-if="scope.row.serviceOrderId && scope.row.serviceOrderId.length > 1">
                                    <el-button v-for="(id, index) in scope.row.serviceOrderId" :key="index"
                                        :disabled="!id" type="success" icon="el-icon-view"
                                        @click="viewWorkOrder({ serviceOrderId: id })" style="margin-top: 10px;">
                                        工单{{ index + 1 }}
                                    </el-button>
                                </div>
                                <div v-else>
                                    <el-button :disabled="!scope.row.serviceOrderId" type="success" icon="el-icon-view"
                                        @click="viewWorkOrder(scope.row)" style="margin-top: 10px;">
                                        工单
                                    </el-button>
                                </div> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="fixed-cards">
                    <div class="card-content" style="text-align: center;">
                        <el-button type="danger" size="small" @click="goBack"
                            icon="el-icon-circle-close-outline">返回</el-button>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { findpreEngineeringOrderDetail } from "@/api/salesCloud/preFilter";
// import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import { DIC } from "@/const/dic";
import { resolveUrlPath } from "@/util/util";
export default {
    data() {
        return {
            tableData: [], // 存放固定字段数据
            isShow: true,
            goodsList: [], // 服务项目列表
            selectedGoods: [], // 用户选择的服务项目
        };
    },
    created() {
        const goodsId = this.$route.query.GoodsId; // 假设产品ID通过路由参数传递
        if (goodsId) {
            this.fetchGoodsData(goodsId);
        }
    },
    methods: {
        getStatusLabel(status) {
            const statusItem = DIC.PRE_FILTER_STATUS.find(item => item.value === status);
            return statusItem ? statusItem.label : status;
        },
        fetchGoodsData(goodsId) {
            const params = {
                id: goodsId,
                qrType: 'ENGINEERING'
            };
            // 获取产品数据
            findpreEngineeringOrderDetail(params).then(res => {
                // console.log('res:::1 ', res);
                if (res.code == "200") {
                    const jsonData = JSON.parse(res.data); // 解析返回的 JSON 数据
                    // console.log('jsonData:::1 ', jsonData);
                    // 填充固定字段数据
                    this.tableData = [{
                        shopName: jsonData.shopName,
                        shopMobile: jsonData.shopMobile,
                        customName: jsonData.customName,
                        customMobile: jsonData.customMobile,
                        customAddress: jsonData.customAddress,
                        engineeringSupervisorName: jsonData.engineeringSupervisorName,
                        engineeringSupervisorMobile: jsonData.engineeringSupervisorMobile,
                        goodsName: jsonData.goodsName,
                        qrcodeName: jsonData.qrcodeName,
                        status: jsonData.status,
                        imageUrl: jsonData.imageUrl ? jsonData.imageUrl : null,
                    }];
                    if (jsonData.child) {
                        // console.log(jsonData.child)
                        this.selectedGoods = jsonData.child;
                    } else {
                        this.isShow = false;
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            }).catch(err => {
                this.$message.error('获取数据失败', err);
            });
        },
        viewWorkOrder(row) {
            console.log('row::: ', row);
            let obj = {
                label: "查看工单",
                value: "/work/engineeringProject/engineer/engineerDetails/details",
                serviceOrderId: row.serviceOrderId,
                id: row.id,
                status: row.status
            };
            this.$router.push({
                path: resolveUrlPath(obj.value, obj.label),
                query: { GoodsId: obj.serviceOrderId, status: obj.status, id: obj.id }
            });
        },
        getSpan(length) {
            // 动态计算每列的span值
            return Math.floor(24 / Math.min(length, 3)); // 最多3列
        },
        // 返回上一步
        goBack() {
            let item = {
                close: true,
                label: "工程服务单",
                value: "/work/engineeringProject/engineer/engineerDetails"
            };
            this.$store.commit("DEL_TAG", item);
            this.$router.go(-1);
        },
        formmaterImage(row) {
            let str = new Array();
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        }
    }
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    min-height: 80%;
    box-sizing: border-box;
    font-family: fangsong;
    font-size: large;
}

.fixed-cards,
.dynamic-cards {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.clearfix {
    font-weight: bold;
}

.gap-line-border {
    padding: 0 10px;
    border: 1px dashed #ccc;
}

.gap-line {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: #ccc;
    margin-top: 10px;
}

.goodsNameStyle {
    font-weight: bold;
    line-height: 4px;
}

.card {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
}

.card:hover {
    transform: scale(1.01);
}

.dynamic-cards:last-child {
    margin-bottom: 30px;
}

.card-content {
    padding: 20px;
    font-family: fangsong;
    word-break: break-word;
    /* 自动换行 */
}

.card p {
    margin: 10px 0;
    line-height: 1.6;
    word-break: break-word;
    /* 自动换行 */
}

.card strong {
    color: #333;
}

.card .el-image {
    border-radius: 5px;
}

.card-image {
    width: 100px;
    height: 100px;
    margin: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
    cursor: pointer;
    transition: transform 0.3s ease;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.form-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
}

.form-row p {
    flex: 1;
    min-width: calc(20% - 10px);
    /* 每行三个内容，减去间隙 */
    box-sizing: border-box;
    margin: 0;
}

.dynamic-cards .card {
    width: 100%;
}

@media (max-width: 768px) {
    .card {
        width: 100%;
    }

    .form-row {
        flex-direction: column;
    }

    .form-row p {
        min-width: 100%;
        /* 小屏幕下每行一个内容 */
    }
}
</style>